import { Directive } from '@angular/core';
import { NG_VALIDATORS, FormControl } from '@angular/forms';

export function validarCNPJ(control: FormControl) {

  const nums = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];


  if (control.value == null) {
    return { erro: 'CNPJ inválido' };
  }

  let cnpj = '';

  for (let index = 0; index < control.value.length; index++) {
    if (nums.some(p => p === Number(control.value[index]))) {
      cnpj += control.value[index];
    }

  }

  cnpj = cnpj.replace(/[^\d]+/g, '');

  if (cnpj === '') {
    return { erro: 'CNPJ inválido' };
  }

  if (cnpj.length !== 14) {
    return { erro: 'CNPJ inválido' };
  }

  // Elimina CNPJs invalidos conhecidos
  if (cnpj === '00000000000000' ||
    cnpj === '11111111111111' ||
    cnpj === '22222222222222' ||
    cnpj === '33333333333333' ||
    cnpj === '44444444444444' ||
    cnpj === '55555555555555' ||
    cnpj === '66666666666666' ||
    cnpj === '77777777777777' ||
    cnpj === '88888888888888' ||
    cnpj === '99999999999999') {
    return { erro: 'CNPJ inválido' };
  }

  // Valida DVs
  let tamanho = cnpj.length - 2;
  let numeros = cnpj.substring(0, tamanho);
  const digitos = cnpj.substring(tamanho);
  let soma = 0;
  let pos = tamanho - 7;

  let i = 0;



  for (i = tamanho; i >= 1; i--) {
    soma += Number(numeros.charAt(tamanho - i)) * pos--;
    if (pos < 2) {
      pos = 9;
    }
  }
  let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
  if (resultado !== Number(digitos.charAt(0))) {
    return { erro: 'CNPJ inválido' };
  }

  tamanho = tamanho + 1;
  numeros = cnpj.substring(0, tamanho);
  soma = 0;
  pos = tamanho - 7;
  for (i = tamanho; i >= 1; i--) {
    soma += Number(numeros.charAt(tamanho - i)) * pos--;
    if (pos < 2) {
      pos = 9;
    }
  }
  resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
  if (resultado !== Number(digitos.charAt(1))) {
    return { erro: 'CNPJ inválido' };
  }

  return null;

}

export function validaCPF(control: FormControl) {

  const nums = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];


  if (control.value == null) {
    return { erro: 'CPF inválido' };
  }

  let cpf = '';

  for (let index = 0; index < control.value.length; index++) {
    if (nums.some(p => p === Number(control.value[index]))) {
      cpf += control.value[index];
    }

  }


  if (cpf.length !== 11) {
    return { erro: 'CPF inválido' };
  }
  if ((cpf === '00000000000') || (cpf === '11111111111') || (cpf === '22222222222') || (cpf === '33333333333') ||
    (cpf === '44444444444') || (cpf === '55555555555') || (cpf === '66666666666') || (cpf === '77777777777') ||
    (cpf === '88888888888') || (cpf === '99999999999')) {
    return { erro: 'CPF inválido' };
  }
  let numero: number = 0;
  let caracter: string = '';
  let numeros: string = '0123456789';
  let j: number = 10;
  let somatorio: number = 0;
  let resto: number = 0;
  let digito1: number = 0;
  let digito2: number = 0;
  let cpfAux: string = '';
  cpfAux = cpf.substring(0, 9);
  for (let i: number = 0; i < 9; i++) {
    caracter = cpfAux.charAt(i);
    if (numeros.search(caracter) === -1) {
      return { erro: 'CPF inválido' };
    }
    numero = Number(caracter);
    somatorio = somatorio + (numero * j);
    j--;
  }
  resto = somatorio % 11;
  digito1 = 11 - resto;
  if (digito1 > 9) {
    digito1 = 0;
  }
  j = 11;
  somatorio = 0;
  cpfAux = cpfAux + digito1;
  for (let i: number = 0; i < 10; i++) {
    caracter = cpfAux.charAt(i);
    numero = Number(caracter);
    somatorio = somatorio + (numero * j);
    j--;
  }
  resto = somatorio % 11;
  digito2 = 11 - resto;
  if (digito2 > 9) {
    digito2 = 0;
  }
  cpfAux = cpfAux + digito2;
  if (cpf !== cpfAux) {
    return { erro: 'CPF inválido' };
  } else {
    return null;
  }

  return null;
}


export function validaCPFCNPJ(control: FormControl) {
  const nums = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];


  if (control.value == null) {
    return { erro: 'CPF / CNPJ inválido' };
  }

  let cpfCnpj = '';

  for (let index = 0; index < control.value.length; index++) {
    if (nums.some(p => p === Number(control.value[index]))) {
      cpfCnpj += control.value[index];
    }
  }

  if (cpfCnpj.length <= 11) {
    return validaCPF(control);
  } else {
    return validarCNPJ(control);
  }
}


@Directive({
  selector: '[appValidaCpf][ngModel]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useValue: validaCPF,
      multi: true
    }
  ]
})
export class ValidaCpfDirective {

  constructor() { }

}

@Directive({
  selector: '[appValidaCpfCnpj][ngModel]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useValue: validaCPFCNPJ,
      multi: true
    }
  ]
})
export class ValidaCpfCNPJDirective {

  constructor() { }

}
